import _property from 'lodash/property';
var id = _property('id');
var name = _property('name');
var filters = _property('filters');
var selected = _property('selected');
var groupName = _property('groupName');

// Filter Readers
var type = _property('type');
var operator = _property('operator');
var values = _property('values');
var defaultGroupIdentifier = _property('defaultGroupIdentifier');
var nonRenamable = _property('nonRenamable');
var nonDeletable = _property('nonDeletable');
var field = _property('field');
var orFilters = _property('orFilters');
var nestedFilter = _property('nestedFilter');
var READER = {
  defaultGroupIdentifier: defaultGroupIdentifier,
  id: id,
  nonRenamable: nonRenamable,
  nonDeletable: nonDeletable,
  name: name,
  filters: filters,
  groupName: groupName,
  selected: selected
};
var FILTER_READER = {
  type: type,
  operator: operator,
  values: values,
  field: field,
  orFilters: orFilters,
  nestedFilter: nestedFilter
};
export { FILTER_READER as filterReader };
export default READER;